/**
 * Minimo de caracteres antes de qualquer pesquisa comecar a filtrar, na tabela ou na barra do topo.
 * Com frota grande, um ou dois caracteres descartam quase nada e mandam redesenhar quase tudo.
 */
export const SEARCH_MIN_LENGTH = 4;
